// extracted by mini-css-extract-plugin
export default {"list":"YourHomeLink_list__+1wby"};